import React from 'react';
import { Box, Typography, alpha } from '@mui/material';
import { useTranslation } from '../../../app/LanguageContext';
import { mediaFileUrl } from './catalogCompositionUtils';

const CatalogTemplateSelector = ({ templates, value, disabled, onChange, compact = false }) => {
  const { translate } = useTranslation();

  if (!templates.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        {translate('catalog.templates.empty')}
      </Typography>
    );
  }

  return (
    <Box
      sx={
        compact
          ? {
              display: 'flex',
              gap: 1,
              overflowX: 'auto',
              pb: 0.5,
              mx: -0.5,
              px: 0.5,
            }
          : {
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(112px, 1fr))',
              gap: 1,
            }
      }
    >
      {templates.map((template) => {
        const selected = template.id === value;
        const imageUrl = mediaFileUrl(template.preview_media_url);
        return (
          <Box
            key={template.id}
            component="button"
            type="button"
            disabled={disabled}
            onClick={() => onChange(template.id)}
            sx={{
              border: 2,
              borderColor: selected ? 'primary.main' : 'divider',
              borderRadius: 1,
              p: 0.75,
              cursor: disabled ? 'default' : 'pointer',
              bgcolor: selected ? (theme) => alpha(theme.palette.primary.main, 0.06) : 'background.paper',
              textAlign: 'left',
              opacity: disabled ? 0.6 : 1,
              flexShrink: compact ? 0 : undefined,
              width: compact ? 108 : undefined,
            }}
          >
            <Box
              sx={{
                width: '100%',
                aspectRatio: '16 / 10',
                borderRadius: 0.5,
                overflow: 'hidden',
                bgcolor: (theme) =>
                  theme.palette.mode === 'dark' ? alpha(theme.palette.common.white, 0.06) : '#ececec',
                mb: 0.75,
              }}
            >
              {imageUrl ? (
                <Box
                  component="img"
                  src={imageUrl}
                  alt={template.name}
                  sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                />
              ) : (
                <Box
                  sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: 0.5,
                  }}
                >
                  <Typography variant="caption" color="text.secondary" align="center">
                    {translate('catalog.templates.card_preview_unavailable')}
                  </Typography>
                </Box>
              )}
            </Box>
            <Typography variant="caption" fontWeight={selected ? 700 : 500} noWrap display="block">
              {template.name}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default CatalogTemplateSelector;
